<nav class="navbar navbar-light sticky-top bg-light">
  <div class="container-fluid">
    <div class="d-flex align-items-center">
      <a class="navbar-brand" routerLink="/">
        <img src="images/logo.png" alt="" height="35" />
      </a>
      <div class="border-start px-4 d-flex flex-column">
        <span class="fs-5 fw-bolder">{{
          commonService.pageHeader.pageTitle
        }}</span>
        @if(commonService.pageHeader.subTitle){

        <span class="fw-bolder small">{{
          commonService.pageHeader.subTitle
        }}</span>
        }
      </div>

      <table class="border-start">
        @if(commonService.pageHeader.headerText1){
        <tr class="">
          <td class="small text-nowrap px-2">
            {{ commonService.pageHeader.headerText1 }}:
          </td>
          <td class="text-nowrap fw-bold px-2">
            {{ commonService.pageHeader.headerValue1 }}
          </td>
        </tr>
        } @if(commonService.pageHeader.headerText2){
        <tr class="">
          <td class="small text-nowrap px-2">
            {{ commonService.pageHeader.headerText2 }}:
          </td>
          <td class="text-nowrap fw-bold px-2">
            {{ commonService.pageHeader.headerValue2 }}
          </td>
        </tr>
        }
      </table>
    </div>
    @if (isLoggedIn && commonService.pageHeader.loggedInUserRole?.length) {
    <div class="ms-auto d-flex align-items-center">
      <ul
        class="navbar-nav d-flex flex-row gap-4 me-5 pe-5 mb-2 mb-lg-0 fw-bolder border-end"
      >
        <li class="nav-item">
          <a
            routerLink="/vendor"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link"
            ><i class="pi pi-home me-1"></i>Dashboard</a
          >
        </li>
        <li class="nav-item">
          <a
            routerLink="/member/member-search"
            routerLinkActive="active"
            class="nav-link"
            [routerLinkActiveOptions]="{ exact: true }"
            ><i class="pi pi-user me-1"></i>Member Search</a
          >
        </li>
      </ul>

      <div class="d-flex flex-column align-items-end">
        <span class="fw-bolder" tabindex="0">
          Welcome, {{ commonService.pageHeader.loggedInUser }}
        </span>
        <span class="fw-bolder small">
          {{ commonService.pageHeader.loggedInUserRole?.join(", ") }}
        </span>
      </div>
      <p-button
        icon="pi pi-sort-down-fill"
        text
        severity="secondary"
        (click)="op.toggle($event)"
      ></p-button>
    </div>
    }
  </div>
</nav>

<p-popover #op>
  <div class="">
    <p-button
      icon="pi pi-sign-out"
      severity="danger"
      text
      (click)="logout()"
      label="Logout"
    >
    </p-button>
  </div>
</p-popover>
